import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import document_type_001 from '../../json/document-type-001-PART.json';
import document_type_002 from '../../json/document-type-002-PART.json';
import document_type_003 from '../../json/document-type-003.json';
import document_type_004 from '../../json/document-type-004.json';
import ReactJson from 'react-json-view'


export default function DocumentTypesGet() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Document Types GET</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                In Enlil, part revisions represent the revisions of documents with a document type group attribute equal to "PART". The part revisions GET API allows for the retrieval of part revision content.
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Header Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-AccessToken (Required String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-AccessToken is obtained during the authentication process and expires after 90 days.</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-RefreshToken (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-RefreshToken is obtained during the authentication process and never expires. This token is provided is the caller wants a refreshed X-Enlil-AccessToken</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>idoc-response (Optional String: Default v1.DocumentType-001)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The name of the IDOC being requested.</li>
                </li>
                <li style={{marginTop: "20px"}}>Basic Query Parameters</li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>USID (Optional String)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The primary key of the part entity</li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>DocumentTypeName (Optional String)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The name of the document type</li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>DocumentTypeAcronym (Optional String)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The acronym associated to the document type. Enlil by default supports the list below and user may add others.</li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>Active (Optional Boolean)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The status of the document type</li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>Group (Optional)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The group associated to the document type. Valid choices are as follows:</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>FORM</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>OTHER</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>PI</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>RECORD</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>CHANGE_REQUEST</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>DAM</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>DYNAMIC_FORM</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>POAM</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>PO</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>SUPPLIER</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>PART</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>RECEIVABLE</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>ENGINEERING_BUILD</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>EQUIPMENT</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>EQUIPMENT_SPECIFICATION</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>MAINTENANCE_RECORD</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>LOT</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>LHR</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>PAPER_LHR</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>LHRT</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>PI_INSTANCE</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>TRAINING_CURRICULUM</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>BULK_CREATE</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>CONFIG_OPTIONS</li>
                <li style={{marginTop: "10px", marginLeft: "60px"}}>WORK_ORDER</li>

                <li style={{marginTop: "20px", marginLeft: "20px"}}>Limit (Optional: Default 5)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The number of rows to return in the primary integration component in the IDOC</li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>Offset (Optional: Default 0)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The number of the row to start with in the result set</li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>Sort (Optional: Default None)</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>The column or columns to sort the results set with in the primary integration component in the IDOC. Example: [Column1: DESC, Column1: ASC]</li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Examples</p>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                Enlil provides several IDOC formats to retrieve part revision related data using the part_revisions GET API. For example, if the user executes this request:<br/><br/>

                <span style={{fontFamily: "Courier New", fontSize: "14px",}}>curl -G -d "USID=88888888-4444-4444-4444-121212121212&limit=5&offset=0" -H "idoc-response: v1.DocumentType-001" -H "X-Enlil-AccessToken: &#60;token&#62;" http://integrate.enlil.io/t3/v1/document_types</span>
                <br/><br/>
                The response will resemble:<br/><br/>

                <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                    <ReactJson src={document_type_001} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Error Codes</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-26F6-48FA - Invalid parameter: Limit</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-A4CB-4944 - Invalid parameter: Offset</li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>IDOCs</p>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                <span style={{textDecoration: "underline"}}><b>v1.DocumentType-001</b></span><br/><br/>
                v1.DocumentType-001 is an IDOC designed to return a list of document type records. v1.DocumentType-001 is limited to a maximum of 40 records per request. To retrieve more, users are advised to paginate using the Limit and Offset query parameters.

                <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                    <ReactJson src={document_type_001} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
            </p>
            <br/>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                <span style={{textDecoration: "underline"}}><b>v1.DocumentType-002</b></span><br/><br/>
                v1.DocumentType-002 is an IDOC designed to return a focused get of a single document type record as specified in the USID parameter and all of its related information such as Document Type Group and Form. v1.DocumentType-002 is limited to a maximum of 1 part record per request.

                <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                    <ReactJson src={document_type_002} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
            </p>
            <br/>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                <span style={{textDecoration: "underline"}}><b>v1.DocumentType-003</b></span><br/><br/>
                v1.DocumentType-003 is an IDOC designed to return a focused get of a single document type record with the intent of retrieving the next document number for the document type. v1.DocumentType-003 is limited to a maximum of 1 part record per request.

                <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                    <ReactJson src={document_type_003} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
            </p>
            <br/>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                <span style={{textDecoration: "underline"}}><b>v1.DocumentType-004</b></span><br/><br/>
                v1.DocumentType-004 is an IDOC designed to return a focused get of a single document type record as specified in the USID parameter and all of its related information such as Form and Page Detail. v1.DocumentType-004 is limited to a maximum of 1 part record per request.

                <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                    <ReactJson src={document_type_004} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
            </p>
        </div>
    )
}